/* HTTP Trips repository — talks to the real backend (API_CONTRACT.md). */
import { apiDelete, apiGet, apiSend } from './httpClient'
import type { CreateTripInput, Trip, UpdateTripInput } from './types'
import { readTripSnapshot } from '../lib/offlineStore'

export function listTrips(): Promise<Trip[]> {
  return apiGet<Trip[]>('/trips')
}

export async function getTrip(id: string): Promise<Trip> {
  try { return await apiGet<Trip>(`/trips/${id}`) }
  catch (error) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      const saved = await readTripSnapshot(id)
      if (saved) return saved.trip
    }
    throw error
  }
}

export function createTrip(input: CreateTripInput): Promise<Trip> {
  return apiSend<Trip>('POST', '/trips', input)
}

export function updateTrip(id: string, patch: UpdateTripInput): Promise<Trip> {
  return apiSend<Trip>('PATCH', `/trips/${id}`, patch)
}

export function deleteTrip(id: string): Promise<void> {
  return apiDelete(`/trips/${id}`)
}

export function duplicateTrip(id: string): Promise<Trip> {
  return apiSend<Trip>('POST', `/trips/${id}/duplicate`)
}
